import { motion, AnimatePresence } from "framer-motion";

const sparkles = ["✨", "💫", "🌟", "🔮", "⭐"];

export default function TrailSwipeTransition({ emoji = "🧑‍🚀", onComplete }) {
  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-br from-purple-800 via-indigo-700 to-pink-600 overflow-hidden"
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        {/* Floating Message */}
        <motion.div
          className="absolute top-16 text-center text-white text-2xl sm:text-3xl font-bold drop-shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          ✨ Preparing your magical maze adventure...
        </motion.div>

        {/* Curved Avatar Path */}
        <motion.div
          className="text-7xl absolute"
          initial={{ x: "-10vw", y: 0, opacity: 0 }}
          animate={{
            x: "110vw",
            y: [0, -30, 20, -20, 0], // 💫 Curved wave path
            opacity: 1
          }}
          transition={{ duration: 2.2, ease: "easeInOut" }}
          onAnimationComplete={() => onComplete?.()}
        >
          <motion.span
            style={{ filter: "drop-shadow(0 0 10px white)" }}
            className="inline-block"
          >
            {emoji}
          </motion.span>
        </motion.div>
        <motion.div
  className="absolute w-full text-center top-[60%] text-white text-lg font-semibold"
  initial={{ opacity: 0, y: 10 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 0.6 }}
>
  Let’s go, {localStorage.getItem("maze-player-name") || "Explorer"}!
</motion.div>



        {/* Sparkle Particles */}
        {Array.from({ length: 10 }).map((_, i) => {
          const sparkle = sparkles[Math.floor(Math.random() * sparkles.length)];
          const top = Math.random() * 100;
          const left = Math.random() * 100;
          const size = Math.random() * 1 + 1;

          return (
            <motion.div
              key={i}
              className="absolute text-white"
              style={{
                top: `${top}%`,
                left: `${left}%`,
                fontSize: `${size}rem`,
                opacity: 0.7,
                pointerEvents: "none"
              }}
              initial={{ y: 0, opacity: 0 }}
              animate={{ y: -30, opacity: 1 }}
              transition={{
                duration: 2,
                delay: Math.random() * 1,
                repeat: Infinity,
                repeatType: "reverse",
                ease: "easeInOut"
              }}
            >
              {sparkle}
            </motion.div>
          );
        })}

        {/* Trail Glow */}
        <motion.div
          className="absolute top-1/2 left-0 w-full h-1 bg-gradient-to-r from-white/50 to-transparent"
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.8 }}
          transition={{ duration: 0.8 }}
        />
      </motion.div>
    </AnimatePresence>
  );
}
